import { useState } from "react";
import api from "../api";
import { useTheme } from "../components/Theme";

const ORANGE = "#FF6B2B";

export default function Login({ onLogin }) {
  const { theme } = useTheme();
  const [form, setForm] = useState({ email: "", senha: "" });
  const [erro, setErro] = useState("");
  const [load, setLoad] = useState(false);
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  // Detectar nome da empresa pelo subdomínio
  const subdomain = window.location.hostname.split(".")[0];
  const nomeEmpresa = subdomain !== "localhost" && subdomain !== "www"
    ? subdomain.charAt(0).toUpperCase() + subdomain.slice(1)
    : "Optimus One";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro(""); setLoad(true);
    try {
      const { data } = await api.post("/auth/login", form);
      localStorage.setItem("oo_token", data.token);
      localStorage.setItem("oo_user", JSON.stringify(data.user));
      onLogin(data.user);
    } catch (err) {
      setErro(err.response?.data?.erro || "Email ou senha incorretos");
    } finally { setLoad(false); }
  };

  return (
    <div style={{
      minHeight: "100vh", background: theme.bg,
      display: "flex", alignItems: "center", justifyContent: "center",
      fontFamily: "'Inter',-apple-system,sans-serif", padding: 24,
    }}>
      <div style={{ width: "100%", maxWidth: 420 }}>

        {/* Logo + Nome */}
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <div style={{ width: 64, height: 64, borderRadius: 18, background: `linear-gradient(135deg, ${ORANGE}, #FF9A5C)`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 32, margin: "0 auto 16px", boxShadow: `0 8px 24px ${ORANGE}44` }}>
            ⚡
          </div>
          <h1 style={{ margin: "0 0 6px", fontSize: 26, fontWeight: 800, color: theme.text }}>{nomeEmpresa}</h1>
          <p style={{ margin: 0, fontSize: 14, color: theme.textMuted }}>Powered by <span style={{ color: ORANGE, fontWeight: 600 }}>Optimus One</span></p>
        </div>

        {/* Card */}
        <div style={{ background: theme.bgCard, borderRadius: 20, border: `1px solid ${theme.border}`, padding: 32, boxShadow: theme.shadowLg }}>
          <h2 style={{ margin: "0 0 24px", fontSize: 20, fontWeight: 700, color: theme.text }}>Entrar na sua conta</h2>

          <form onSubmit={handleSubmit}>
            {[["Email", "email", "email"], ["Senha", "senha", "password"]].map(([label, key, type]) => (
              <div key={key} style={{ marginBottom: 16 }}>
                <label style={{ fontSize: 12, fontWeight: 600, color: theme.textMuted, display: "block", marginBottom: 6, letterSpacing: ".02em" }}>{label.toUpperCase()}</label>
                <input type={type} value={form[key]} onChange={e => set(key, e.target.value)} required
                  style={{ width: "100%", boxSizing: "border-box", background: theme.bgInput, border: `1.5px solid ${theme.border}`, borderRadius: 10, padding: "11px 14px", color: theme.text, fontSize: 14, outline: "none", colorScheme: theme.name, fontFamily: "inherit", transition: "border-color .15s" }}
                  onFocus={e => e.target.style.borderColor = ORANGE}
                  onBlur={e => e.target.style.borderColor = theme.border} />
              </div>
            ))}

            {erro && (
              <div style={{ background: "#ef444418", border: "1px solid #ef444433", borderRadius: 10, padding: "10px 14px", color: "#ef4444", fontSize: 13, marginBottom: 16 }}>
                ⚠️ {erro}
              </div>
            )}

            <button type="submit" disabled={load} style={{
              width: "100%", background: `linear-gradient(135deg, ${ORANGE}, #FF9A5C)`,
              border: "none", borderRadius: 12, padding: "13px 0",
              color: "#fff", fontWeight: 700, fontSize: 15, cursor: load ? "not-allowed" : "pointer",
              opacity: load ? .8 : 1, fontFamily: "inherit",
              boxShadow: `0 4px 14px ${ORANGE}44`, transition: "opacity .15s, transform .1s"
            }}
              onMouseEnter={e => { if (!load) e.currentTarget.style.transform = "translateY(-1px)"; }}
              onMouseLeave={e => e.currentTarget.style.transform = "none"}>
              {load ? "Entrando..." : "Entrar"}
            </button>
          </form>
        </div>

        <div style={{ textAlign: "center", marginTop: 20, fontSize: 12, color: theme.textMuted }}>
          Problemas com acesso? Entre em contato com seu administrador.
        </div>
      </div>
    </div>
  );
}
